<template>
    <div class="component">
        <h1>Temperaturkurve</h1>
        <template v-if="initialized">

            <TabSelector :tabs
                         :tab
                         @changeTab="handleChangeTab"/>

            <CChart :custom-tooltips="false"
                    type="line"
                    :wrapper=false
                    :data="preparedData"
                    :options
                    :plugins/>

            <Slider id="niveau" :min=-20 :max=20 :value="setup[tab.id].niveau" label="Niveau"
                    @update="handleChange( 'niveau', $event )"/>
            <Slider id="gradient" :min=0 :max=200 :value="( setup[tab.id].gradient * 100 )" label="Steigung"
                    @update="handleChange( 'gradient', $event )"/>

            <button class="fullsize" @click="handleStore()">übernehmen</button>
            <pre v-if="debug">
                {{ temp }}
            </pre>

        </template>
    </div>
</template>
<script>

import { CChart }  from "@coreui/vue-chartjs";
import TabSelector from "@/components/parts/TabSelector.vue";
import Slider      from "@/components/parts/Slider.vue";

export default {
    name      : "Delivery",
    components: { TabSelector, Slider, CChart },
    data()
    {
        return {
            debug       : false,
            setup       : {},
            data        : false,
            temp        : false,
            max         : 20,
            min         : -20,
            step        : 5,
            preparedData: {
                labels  : [],
                datasets: []
            },
            localSetup  : false,
            tabs        : [],
            tab         : false,
            options     : {
                interaction: {
                    mode     : "index",
                    intersect: false
                },
                responsive : true,
                stacked    : false,
                scales     : {
                    x: {
                        grid : {
                            color: '#1a1a1a',
                        },
                        title: {
                            display: true,
                            text   : "Außentemperatur °C"
                        }
                    },
                    y: {
                        grid : {
                            color: '#2c2c2c',
                        },
                        title: {
                            display: true,
                            text   : "Vorlauftemperatur °C"
                        },
                    },
                },
                legend     : { display: false }
            },
            plugins     : {
                tooltip: {
                    enabled: true,
                    //mode: "point",
                    //position: "nearest",
                    callbacks: {
                        // custom label callback function
                        title: function( context )
                        {
                            let suffix = "°C";
                            let tt_title = "Bei ${context[0].label} ${suffix} Außentemperatur";

                            return tt_title;
                        },
                        label: function( context )
                        {

                            let suffix = "°C";
                            let label = "${context.dataset.label} ${context.parsed.y} ${suffix}";

                            return label;
                        },
                    },
                },
            },
            initialized : false
        }
    },

    created()
    {

        this.readConfig()

    },

    mounted()
    {

    },

    methods: {

        reset()
        {
            this.preparedData = {
                labels  : [],
                datasets: []
            }
        },

        handleChangeTab( which )
        {

            this.tab = which

            this.initialized = false
            this.reset()
            this.initGraph()

        },

        readConfig()
        {
            return new Promise( resolve =>
            {

                let message = {
                    method: 'uhc.getConfig',
                    plain : false
                }

                this.$core
                    .getWebsockets()
                    .request( message )
                    .then( response =>
                    {

                        let result = JSON.parse( response ),
                            data   = {
                                1: {
                                    x        : [],
                                    y_default: [],
                                    y_night  : []
                                },
                                2: {
                                    x        : [],
                                    y_default: [],
                                    y_night  : []
                                },
                            }

                        this.temp = result
                        this.data = data

                        if( result && result.result )
                        {
                            let values = result.result
                            this.setup = {
                                1: values && values.logic && values.logic.circuits ? values.logic.circuits[ 1 ] : {},
                                2: values && values.logic && values.logic.circuits ? values.logic.circuits[ 2 ] : {},
                            }
                            if( values && values.logic && values.logic.circuits && values.logic.circuits[ 1 ] )
                            {

                                this.tabs.push( {
                                    id   : 1,
                                    label: values.logic.circuits[ 1 ].name
                                } )

                                this.$core
                                    .f()
                                    .generateGraphData( this.setup[ 1 ].roomtemperature.default, this.setup[ 1 ].niveau, this.setup[ 1 ].gradient, this.max, this.min, this.step, this.data[ 1 ], false )

                                this.$core
                                    .f()
                                    .generateGraphData( this.setup[ 1 ].roomtemperature.night, this.setup[ 1 ].niveau, this.setup[ 1 ].gradient, this.max, this.min, this.step, this.data[ 1 ], true )

                            }
                            if( values && values.logic && values.logic.circuits && values.logic.circuits[ 2 ] )
                            {

                                this.tabs.push( {
                                    id   : 2,
                                    label: values.logic.circuits[ 2 ].name
                                } )

                                this.$core
                                    .f()
                                    .generateGraphData( this.setup[ 2 ].roomtemperature.default, this.setup[ 2 ].niveau, this.setup[ 2 ].gradient, this.max, this.min, this.step, this.data[ 2 ], false )

                                this.$core
                                    .f()
                                    .generateGraphData( this.setup[ 2 ].roomtemperature.night, this.setup[ 2 ].niveau, this.setup[ 2 ].gradient, this.max, this.min, this.step, this.data[ 2 ], true )


                            }
                        }

                        this.handleChangeTab( { id: 1 } )

                        return resolve()

                    } )

            } )
        },

        initGraph()
        {
            this.$nextTick()
                .then( () =>
                {

                    this.preparedData.labels = this.data[ this.tab.id ].x

                    this.preparedData.datasets.push( {
                        label               : 'Standard',
                        backgroundColor     : 'pink',
                        borderColor         : 'pink',
                        fill                : false,
                        pointBackgroundColor: 'red',
                        pointBorderColor    : 'red',
                        data                : this.data[ this.tab.id ].y_default
                    } )

                    this.preparedData.datasets.push( {
                        label               : 'Abgesenkt',
                        backgroundColor     : 'lightblue',
                        borderColor         : 'lightblue',
                        fill                : false,
                        pointBackgroundColor: 'blue',
                        pointBorderColor    : 'blue',
                        data                : this.data[ this.tab.id ].y_night
                    } )

                    this.$nextTick()
                        .then( () =>
                        {

                            this.initialized = true

                        } )

                } )
        },


        handleChange( scope, value )
        {

            switch( scope )
            {
                case 'gradient':
                    value = value / 100
                    break
                default:
            }

            let key     = 'logic.circuits.' + this.tab.id + '.' + scope,
                message = {
                    method: 'uhc.setConfig',
                    key   : key,
                    value : value,
                    plain : false
                }

            this.localSetup = message

        },

        handleStore()
        {

            if( this.localSetup )
            {

                this.$core
                    .getWebsockets()
                    .request( this.localSetup )
                    .then( () =>
                    {

                        setTimeout( () =>
                        {
                            this.tabs = []
                            this.reset()
                            this.readConfig()
                                .then( () =>
                                {
                                    this.$nextTick()
                                        .then( () =>
                                        {
                                            this.handleChangeTab( this.tab )
                                        } )
                                } )
                        }, 300 )

                    } )

            }

        }

    }

}
</script>